<template>
    <div class="block block-rounded question-container">
        <div class="container rounded-16 pt-4 pb-0" style="border: 1px solid #f8f9f9" :id="'question-container-' + identifier">
            <div class="block-header py-2">
                <h3 class="block-title d-flex justify-content-center text-light-blue">{{ $t('common.add_question') }}</h3>
                <div class="block-options d-flex pb-2 pe-2">
                    <button
                        type="button"
                        @click="upClickHandler"
                        class="btn btn-arrow-question ms-2 rounded-circle"
                        v-if="indexQuestion > 0"
                    >
                        <i class="fa fa-arrow-up" aria-hidden="true"></i>
                    </button>
                    <button
                        type="button"
                        @click="remove"
                        class="btn btn-minuss-question me-1 rounded-circle ms-2"
                        v-if="question.is_deleted == 1 || question.is_deleted == true"
                    >
                        <i class="fa fa-fw fa-minus fs-xs text-grey"></i>
                    </button>
                    <button type="button" @click="hide" class="btn btn-arrow-question ms-2 rounded-circle">
                        <i v-if="opened" class="fa fa-fw fa-chevron-up"></i>
                        <i v-else class="fa fa-fw fa-chevron-down"></i>
                    </button>
                    <button
                        type="button"
                        @click="lowClickHandler"
                        class="btn btn-arrow-question ms-2 rounded-circle"
                        v-if="indexQuestion < lengthQuestions - 1"
                    >
                        <i class="fa fa-arrow-down" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            <div ref="content" class="block-content block-content-full rounded-8 border-left-pink">
                <div class="container justify-content-center py-3 px-6">
                    <div class="col-12">
                        <div class="row p-2">
                            <div class="col-12">
                                <div class="row">
                                    <label class="form-label p-0" for="question">{{ $t('survey.question') }}</label>
                                    <input
                                        type="text"
                                        class="question form-control"
                                        id="question"
                                        :disabled="question.is_disabled == true"
                                        :readonly="question.is_deleted == 0 || question.is_deleted == false"
                                        :name="'form-' + identifier + '[question]'"
                                        :placeholder="$t('survey.question_placeholder')"
                                        v-model="question.question"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div :class="question.type != null && question.type < 4 ? 'col-lg-4 col-md-6' : 'col-lg-8 col-md-6'">
                                <div :id="'container-answer-' + identifier" class="form-group">
                                    <label class="form-label mt-4" for="type">{{ $t('survey.response_type') }}</label>
                                    <select
                                        :disabled="question.is_disabled == true"
                                        class="form-select type"
                                        :id="'form-select-' + identifier"
                                        :name="'form-' + identifier + '[type]'"
                                        v-model="question.type"
                                    >
                                        <option value="1">{{ $t('survey.types.multiple_choice') }}</option>
                                        <option value="2">{{ $t('survey.types.single_choice') }}</option>
                                        <option value="3">{{ $t('survey.types.choice_list') }}</option>
                                        <option value="4">{{ $t('survey.types.free_choice_text') }}</option>
                                        <option value="5">{{ $t('survey.types.free_choice_number') }}</option>
                                        <option value="6">{{ $t('survey.types.date_time') }}</option>
                                        <option value="7">{{ $t('survey.types.date') }}</option>
                                        <option value="8">{{ $t('survey.types.time') }}</option>
                                        <option value="9" v-if="boundsEnabled">{{ $t('survey.types.long_text') }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 mt-4" v-if="question.type != null && question.type < 4">
                                <div class="form-group">
                                    <label class="form-label" for="numberQuestion_valid">{{
                                        $t('survey.correct_answers_count')
                                    }}</label>
                                    <input
                                        type="number"
                                        class="question form-control"
                                        id="numberQuestion_valid"
                                        :name="'form-' + identifier + '[numberQuestion_valid]'"
                                        :placeholder="$t('survey.number_placeholder')"
                                        :readonly="question.is_deleted == 0 || question.is_deleted == false"
                                        v-model="question.numberQuestion_valid"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 mt-4">
                                <div class="form-group">
                                    <label class="form-label" for="is_required">{{ $t('survey.required_response') }}</label>
                                    <div class="d-flex mt-4">
                                        <h6 class="fs-6 fw-medium ppv2-text-black pt-1">{{ $t('common.no') }}</h6>
                                        <div class="form-check form-switch me-4">
                                            <input
                                                type="checkbox"
                                                v-model="question.is_required"
                                                :name="'form-' + identifier + '[is_required]'"
                                                class="form-control form-check-input"
                                            />
                                            <input
                                                type="hidden"
                                                v-model="question.is_deleted"
                                                :name="'form-' + identifier + '[is_deleted]'"
                                            />
                                        </div>
                                        <h6 class="fs-6 fw-medium ppv2-text-black pt-1">{{ $t('common.yes') }}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-4" v-if="boundsEnabled && (question.type == 5 || question.type == 9)">
                            <div class="col-md-6 col-lg-4 mt-4" v-if="question.type == 5 || question.type == 9">
                                <div class="form-group">
                                    <label class="form-label" for="min_value">{{ $t('survey.min_value') }}</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        :id="'min_value-' + identifier"
                                        :name="'form-' + identifier + '[min_value]'"
                                        :placeholder="$t('survey.min_value_placeholder')"
                                        v-model="question.min_value"
                                        :readonly="question.is_deleted == 0 || question.is_deleted == false"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 mt-4">
                                <div class="form-group">
                                    <label class="form-label" for="max_value">{{ $t('survey.max_value') }}</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        :id="'max_value-' + identifier"
                                        :name="'form-' + identifier + '[max_value]'"
                                        :placeholder="$t('survey.max_value_placeholder')"
                                        v-model="question.max_value"
                                        :readonly="question.is_deleted == 0 || question.is_deleted == false"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row mb-4">
                            <div
                                :id="'answers-' + identifier"
                                v-if="question.answers_possibilities.length != 0 && question.type != null && question.type < 4"
                            >
                                <label class="form-label mt-4" for="answers" v-if="question.type != null && question.type < 4">{{
                                    $t('survey.response_possibilities')
                                }}</label>
                                <div
                                    class="d-flex mb-2 flex-wrap"
                                    :id="'answers-container-' + index + '-form-' + identifier"
                                    v-for="(possibility, index) in question.answers_possibilities"
                                    :key="index"
                                >
                                    <!-- <input
                                        v-if="parentQuestion"
                                        type="hidden"
                                        :name="'form-' + identifier + '[parentQuestion]'"
                                        :value="parentQuestion + '$' + parentPossitility"
                                    /> -->

                                    <input
                                        type="text"
                                        :disabled="question.is_disabled == true"
                                        :name="'form-' + identifier + '[possibilities][]'"
                                        class="form-control col-lg-11 col-md-11 col-sm-10"
                                        v-model="question.answers_possibilities[index].possibility"
                                        :id="'answer' + index"
                                    />

                                    <i
                                        @click="deleteAnswer(index)"
                                        class="d-flex align-items-center text-danger fa fa-fw fa-minus btn-minuss-question text-grey fs-xs me-1 ms-2 mt-2"
                                    ></i>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center flex-wrap gap-3">
                            <div>
                                <div
                                    :id="'button-container-form-' + identifier"
                                    v-if="question.type != null && question.type < 4"
                                    class="button-container-form d-flex justify-content-start"
                                >
                                    <div>
                                        <button
                                            :id="'add-button-form-' + identifier"
                                            @click="addAnswer"
                                            type="button"
                                            class="add-button-form btn btn-dark height_btn_page fw-semibold rounded-12 ms-1 mb-3 text-white"
                                        >
                                            <span> {{ $t('survey.add_response') }} </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="text-danger" v-if="question.is_deleted == 1 || question.is_deleted == true">
                                <button
                                    :id="'delete-question-form-' + identifier"
                                    type="button"
                                    class="delete-question-form btn btn-outline-dark height_btn_page fw-semibold rounded-12 me-1 mb-3"
                                    @click="deleteQuestion"
                                >
                                    <span> {{ $t('survey.delete_question') }} </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <input type="hidden" :name="'form-' + identifier + '[id]'" :value="question.id" />
    </div>
</template>

<script>
export default {
    name: 'SurveyQuestion',
    props: ['question', 'identifier', 'indexQuestion', 'lengthQuestions', 'boundsEnabled'],
    data: function () {
        return {
            // Commenté : cause erreur console, inutilisable pour le moment
            //   optionNotCategory: this.question.question_have_categories[0] ? this.question.question_have_categories[0].id : 0,
            //   optionCategory: this.question.question_have_not_categories[0] ? this.question.question_have_not_categories[0].id : 0,
            index: 0,
            currentAnswer: '',
            opened: true,
        }
    },
    mounted() {
        console.log(this.indexQuestion)
        if (typeof this.question.id === 'number') {
            //console.log('mounted' + this.question.is_deleted)
            this.identifier = this.question.id
        }
    },
    // computed: {
    //     optionValue: function () {
    //         return this.question.type
    //     },
    // },
    methods: {
        includes(collection, value) {
            try {
                let found = false

                collection.forEach((element) => {
                    if (element.id === value) {
                        found = true
                        return true
                    }
                })

                return found
            } catch (e) {
                return false
            }
        },

        hide() {
            if (this.opened) {
                this.opened = false
                this.$refs.content.style.height = 0
                this.$refs.content.style.padding = 0
                this.$refs.content.style.overflow = 'hidden'
            } else {
                this.opened = true
                this.$refs.content.style.height = 'initial'
                this.$refs.content.style.padding = '1.25rem'
                this.$refs.content.style.overflow = 'visible'
            }
        },

        remove() {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },

        addAnswer() {
            this.question.answers_possibilities.push({
                created_at: new Date(),
                form_id: this.identifier,
                possibility: this.currentAnswer,
                question_id: this.index,
                updated_at: new Date(),
            })
            this.$forceUpdate()
            this.index++
            this.$forceUpdate()
        },

        deleteAnswer(index) {
            this.question.answers_possibilities.splice(index, 1)
            this.$forceUpdate()
        },
        showQuestion() {
            this.question.is_in_customer_card = !this.question.is_in_customer_card
            this.$forceUpdate()
        },
        upClickHandler() {
            this.$emit('up-event', this.indexQuestion)
        },
        lowClickHandler() {
            this.$emit('low-event', this.indexQuestion)
        },

        deleteQuestion() {
            console.log(this.question.id)
            this.$emit('delete-event', this.identifier)
        },

        upHandler(index) {
            if (index >= 1) {
                const a = this.questions[index]
                const b = this.questions[index - 1]
                this.questions[index] = b
                this.questions[index - 1] = a
                this.$forceUpdate()
            }
        },
        lowHandler(index) {
            // console.log(this.questions)
            if (index < this.questions.length - 1) {
                const a = this.questions[index]
                const b = this.questions[index + 1]
                this.questions[index] = b
                this.questions[index + 1] = a
                this.$forceUpdate()
            }
        },
        deleteHandler(index) {
            this.questions.splice(index, 1)
            this.$forceUpdate()
        },
    },
}
</script>
